module.exports = __webpack_public_path__ + "static/media/01-Follo-create-campaign.528be684.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/pdfs/follo/en/01-Follo-create-campaign.pdf
// module id = ./src/statsradio/modules/tutorials/assets/pdfs/follo/en/01-Follo-create-campaign.pdf
// module chunks = 18